import styled from "styled-components";

export const ActionsContainer = styled.div<{ editMode: boolean }>`
  margin-top: 35px;
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: ${({ editMode }) =>
    editMode ? "space-between" : "flex-end"};
`;

export const ContainerDriverSelected = styled.div`
  display: flex;
  width: 160px;
  align-items: center;
  gap: 10px;
`;

export const ContainerDrive = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const ContainerText = styled.div`
  display: flex;
  margin-top: -3px;
  flex-direction: column;
  h6 {
    max-width: 170px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const ContainerAutoComplete = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ContainerButtonsDrive = styled.div`
  display: flex;
  gap: 10px;
`;
